export enum GPTPromptRoleType {
    SYSTEM = 'system',
    ASSISTANT = 'assistant',
    USER = 'user'
}

export interface GPTPrompt {
    role: GPTPromptRoleType
    content: string
}


export enum LLMVendorType {
    OPENAI = "openai",
    LLM42 = "llm42",
    AZURE_OPENAI = "azure-openai",
    NAVER = "naver",
    META = "meta",
    ANTHROPIC = 'anthropic',
}
